/* eslint-disable react-native-a11y/has-valid-accessibility-ignores-invert-colors */
import React, { FunctionComponent, useContext } from 'react'
import { ImageSourcePropType } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import {
  AuroraCareNavigatorsSquare,
  AuroraCareNavigatorsSquareDesktop,
  CareNavigatorsSquare as imageMobile,
  CareNavigatorsSquareDesktop as imageWeb,
} from '../../assets'
import { LyraSelectCareNavigator } from '../../assets/microsite'
import { IS_WEB } from '../../constants'
import { ProductTypeContext, ThemeType, tID } from '../../utils'
import { Image } from '../image/Image'

const LYRA_SELECT_CARE_NAV_IMG_ASPECT_RATIO = 603 / 616

type PathwaysCareNavigatorIllustrationProps = {
  width?: number
  height?: number
}

const ImageContainer = styled(Image)<{ width: number; height: number }>(({ width, height }) => ({
  width: `${width}px`,
  height: `${height}px`,
}))

export const PathwaysCareNavigatorIllustration: FunctionComponent<PathwaysCareNavigatorIllustrationProps> = ({
  width = 201,
  ...props
}) => {
  let height = width
  const { isLyraSelect } = useContext(ProductTypeContext)
  const { isAuroraTheme } = useTheme() as ThemeType

  let imageSource: ImageSourcePropType

  if (isAuroraTheme) {
    imageSource = (IS_WEB ? AuroraCareNavigatorsSquareDesktop : AuroraCareNavigatorsSquare) as ImageSourcePropType
  } else if (isLyraSelect) {
    imageSource = LyraSelectCareNavigator as ImageSourcePropType
    height = width / LYRA_SELECT_CARE_NAV_IMG_ASPECT_RATIO
  } else {
    imageSource = (IS_WEB ? imageWeb : imageMobile) as ImageSourcePropType
  }

  return (
    <ImageContainer
      width={width}
      height={height}
      testID={`${tID('LiveChatIllustrationIcon')}`}
      source={imageSource}
      {...props}
    />
  )
}
